import React from 'react';
import PropTypes from 'prop-types';

import './Checkbox.scss';

const Checkbox = props => (
  <div className="Checkbox" id={props.id} onClick={props.handleSelect}>
    <span className="item">
      <span className={`${props.checked ? ' active' : ''}`} />
    </span>
    <span className="label">{props.label}</span>
  </div>
);

Checkbox.propTypes = {
  'checked': PropTypes.bool.isRequired,
  'label': PropTypes.string.isRequired,
  'handleSelect': PropTypes.func,
  'id': PropTypes.string,
};

export default Checkbox;
